// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__2-dpb","visibleHandle":"Handle_visibleHandle__1cQAv","dragged":"Handle_dragged__201iF"};